export default __webpack_public_path__ + "static/media/discord-icon.9c63430e.png";